import type { SidebarItemLabelSize } from "./sidebar-menu.types";

export const SIDEBAR_PX_COLLAPSED = "px-3";
export const SIDEBAR_PX_EXPANDED = "px-4";

export const SIDEBAR_MENU_ITEM_ICON =
  "relative inline-flex size-4 flex-shrink-0 items-center justify-center";

export const SIDEBAR_MENU_ITEM_ICON_COMPACT =
  "relative inline-flex size-4 shrink-0 items-start justify-start";

export const SIDEBAR_MENU_ITEM_LABEL_BASE =
  "ml-2 truncate font-semibold transition-all duration-200 whitespace-nowrap overflow-hidden";

export const SIDEBAR_MENU_ITEM_LABEL_BASE_COMPACT =
  "ml-2 min-w-0 flex-1 text-left font-semibold transition-all duration-200 whitespace-normal break-words";

export const SIDEBAR_MENU_ITEM_LABEL_SIZE_DEFAULT = "text-base leading-6";
export const SIDEBAR_MENU_ITEM_LABEL_SIZE_SM = "text-sm leading-5";

export const SIDEBAR_MENU_ITEM_LABEL_HIDDEN =
  "ml-0 max-w-0 flex-none overflow-hidden p-0 opacity-0";

export const SIDEBAR_MENU_ITEM_LABEL_COLLAPSED = SIDEBAR_MENU_ITEM_LABEL_HIDDEN;
export const SIDEBAR_MENU_ITEM_LABEL_EXPANDED = "max-w-52 opacity-100";
export const SIDEBAR_MENU_ITEM_LABEL_EXPANDED_COMPACT = "opacity-100";

export const SIDEBAR_MENU_ITEM_ACCESSORY_DEFAULT = "ml-auto flex shrink-0 items-center self-center";
export const SIDEBAR_MENU_ITEM_ACCESSORY_COMPACT = "ml-auto flex shrink-0 items-center self-center";

export const getSidebarMenuItemClasses = (
  itemLabelSize: SidebarItemLabelSize,
  isCollapsed = false,
) => {
  if (isCollapsed) {
    return {
      icon: SIDEBAR_MENU_ITEM_ICON,
      labelBase: SIDEBAR_MENU_ITEM_LABEL_HIDDEN,
      labelExpanded: "",
      accessory: SIDEBAR_MENU_ITEM_ACCESSORY_DEFAULT,
    };
  }

  const isCompact = itemLabelSize === "sm";

  return {
    icon: isCompact ? SIDEBAR_MENU_ITEM_ICON_COMPACT : SIDEBAR_MENU_ITEM_ICON,
    labelBase: isCompact ? SIDEBAR_MENU_ITEM_LABEL_BASE_COMPACT : SIDEBAR_MENU_ITEM_LABEL_BASE,
    labelExpanded: isCompact
      ? SIDEBAR_MENU_ITEM_LABEL_EXPANDED_COMPACT
      : SIDEBAR_MENU_ITEM_LABEL_EXPANDED,
    accessory: isCompact
      ? SIDEBAR_MENU_ITEM_ACCESSORY_COMPACT
      : SIDEBAR_MENU_ITEM_ACCESSORY_DEFAULT,
  };
};
